import React, { useEffect, useState } from 'react';
import IndicentReportForm from '../incident-reports/IndicentReportForm';
import { useLocation } from 'react-router';
import axios from 'axios';
import { CircularProgress } from '@material-ui/core';

const TeacherIncidentReport = () => {
	const location = useLocation();
	const [teacherProfile, setTeacherProfile] = useState(null);
	const [teacherProfileLoading, setTeacherProfileLoading] = useState(true);
	const [error, setError] = useState(null);
	const teacherToken = new URLSearchParams(location.search).get('token');

	useEffect(() => {
		if (!teacherToken) return;
		const newAxios = axios.create({
			headers: {
				Authorization: `Bearer ${teacherToken}`,
			},
		});

		newAxios
			.get('/api/v2/profile')
			.then((res) => {
				setTeacherProfile(res.data);
				setTeacherProfileLoading(false);
			})
			.catch((error) => {
				console.error('Failed to fetch teacher profile:', error);
				setError(error);
			});
	}, [teacherToken]);

	if (error) {
		return (
			<div className="flex flex-col w-full h-full bg-white">
				<div className="flex justify-center items-center h-full flex-col gap-16">
					<h1 className="text-24 font-inter font-bold">Something went wrong.</h1>
					<p className="text-16 font-inter">Please make sure you are logged in.</p>
				</div>
			</div>
		);
	}

	return (
		<div className="flex flex-col w-full h-full bg-white">
			{teacherProfileLoading ? (
				<div className="flex justify-center items-center h-full">
					<CircularProgress />
				</div>
			) : (
				<IndicentReportForm isAdmin={false} teacherProfile={teacherProfile} teacherToken={teacherToken} />
			)}
		</div>
	);
};

export default TeacherIncidentReport;
